import { Injectable } from '@angular/core';

import type {
  IntegrationHttpApiRequestOptions,
  IntegrationsHttpRequestData,
} from '@core/integrations-http-legacy';

import { RecruiteeRequestData } from './recruitee-request-data';

@Injectable()
export class IntegrationsRequestData
  extends RecruiteeRequestData
  implements IntegrationsHttpRequestData
{
  public buildUrl(path: string, requestOptions?: IntegrationHttpApiRequestOptions): string {
    const baseUrl = `${this.environment.integrations.integrationsUrl}/api`;
    const contextPart = !!requestOptions?.context ? `${requestOptions.context}` : '';
    const companyPart = requestOptions?.skipCompany ? null : `c/${this.currentCompanyId}`;

    return [baseUrl, contextPart, companyPart, path].filter(part => !!part).join('/');
  }
}
